import advertisingApi from '@/api/advertising';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    listPlatforms: null,
    listSources: null
}

export const mutationTypes = {
    getPlatformsStart: '[platforms] get list platforms start',
    getPlatformsSuccess: '[platforms] get list platforms success',
    getPlatformsFailure: '[platforms] get list platforms failure',

    getSourcesStart: '[sources] get list sources start',
    getSourcesSuccess: '[sources] get list sources success',
    getSourcesFailure: '[sources] get list sources failure',
}

export const advertisingActionTypes = {
    getPlatforms: '[platforms] get list platforms',
    getSources: '[sources] get list sources',
}

const mutations = {
    [mutationTypes.getPlatformsStart](state) {
        state.isLoading = true
        state.listPlatforms = null
    },
    [mutationTypes.getPlatformsSuccess](state, payload) {
        state.isLoading = false
        state.listPlatforms = payload
        state.validationErrors = null
    },
    [mutationTypes.getPlatformsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getSourcesStart](state) {
        state.isLoading = true
        state.listSources = null
    },
    [mutationTypes.getSourcesSuccess](state, payload) {
        state.isLoading = false
        state.listSources = payload
        state.validationErrors = null
    },
    [mutationTypes.getSourcesFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [advertisingActionTypes.getPlatforms](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getPlatformsStart)
            advertisingApi
                .getPlatforms(data)
                .then(response => {
                    context.commit(mutationTypes.getPlatformsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getPlatformsFailure,response)
                })
        })
    },
    [advertisingActionTypes.getSources](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSourcesStart)
            advertisingApi
                .getSources(data)
                .then(response => {
                    context.commit(mutationTypes.getSourcesSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSourcesFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}